export type SubscriptionStatus =
  | 'trial'
  | 'active'
  | 'past_due'
  | 'canceled'
  | 'incomplete'
  | 'incomplete_expired'
  | 'unpaid'
  | 'free';

export type PaywallBlockReason =
  | 'not_authenticated'
  | 'trial_expired'
  | 'daily_limit_reached'
  | 'no_profile';

export interface SubscriptionLimits {
  freeDailySessionLimit: number;
}

export const SUBSCRIPTION_LIMITS: SubscriptionLimits = {
  freeDailySessionLimit: 3, // Updated to 3 sessions per day for free tier
};

export const PAYWALL_MESSAGES: Record<PaywallBlockReason, string> = {
  not_authenticated: 'Sign in to start your deep work journey with Pravos.',
  no_profile: 'Complete your profile setup to unlock your first focus session.',
  trial_expired: 'Your Pravos Pro trial has ended. Upgrade now to continue your deep work practice with unlimited focus sessions.',
  daily_limit_reached: 'You\'ve completed your 3 daily sessions. Upgrade to Pravos Pro for unlimited deep work sessions and unlock your full potential.',
};
